(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-custom-select')) {
    const initializedDefaultKeys = new Set();

    class VariantCustomSelect extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.select = this.querySelector('[data-native-select]');
        this.trigger = this.querySelector('[data-custom-select-trigger]');
        this.value = this.querySelector('[data-custom-select-value]');
        this.menu = this.querySelector('[data-custom-select-menu]');
        this.items = Array.from(this.querySelectorAll('[data-option-index]'));

        if (!this.select || !this.trigger || !this.menu || !this.items.length) return;

        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onNativeChange = this.syncFromNativeSelect.bind(this);

        this.trigger.addEventListener('click', () => this.toggle());
        this.addEventListener('keydown', this.onKeydown);
        this.select.addEventListener('change', this.onNativeChange);
        document.addEventListener('click', this.onDocumentClick);

        const defaultChanged = this.applyDefaultValueOnce();

        this.items.forEach((item) => {
          item.addEventListener('click', () => {
            this.choose(Number(item.dataset.optionIndex));
          });
        });

        this.syncFromNativeSelect();

        if (defaultChanged) {
          queueMicrotask(() => {
            if (this.isConnected) {
              this.select.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.select?.removeEventListener('change', this.onNativeChange);
      }

      get isOpen() {
        return this.trigger.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.menu.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');

        requestAnimationFrame(() => {
          const selectedItem = this.items[this.select.selectedIndex] || this.items[0];
          selectedItem?.focus();
        });
      }

      close({ restoreFocus = false } = {}) {
        this.menu.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.trigger.focus();
      }

      toggle() {
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      applyDefaultValueOnce() {
        const defaultValue = this.dataset.defaultValue;
        const defaultKey = this.dataset.defaultKey;

        if (!defaultValue || !defaultKey || initializedDefaultKeys.has(defaultKey)) {
          return false;
        }

        initializedDefaultKeys.add(defaultKey);

        const defaultIndex = Array.from(this.select.options).findIndex(
          (option) => option.value === defaultValue
        );

        if (defaultIndex < 0 || defaultIndex === this.select.selectedIndex) {
          return false;
        }

        this.select.selectedIndex = defaultIndex;
        return true;
      }

      choose(index) {
        if (!Number.isInteger(index) || !this.select.options[index]) return;

        const changed = this.select.selectedIndex !== index;
        this.select.selectedIndex = index;
        this.syncFromNativeSelect();
        this.close({ restoreFocus: true });

        if (changed) {
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncFromNativeSelect() {
        const selectedIndex = Math.max(this.select.selectedIndex, 0);
        const selectedOption = this.select.options[selectedIndex];
        const selectedItem = this.items[selectedIndex];

        if (selectedItem && this.value) {
          const itemLabel = selectedItem.querySelector('span');
          this.value.textContent = itemLabel?.textContent.trim() || selectedOption?.value || '';
        }

        this.items.forEach((item, index) => {
          item.setAttribute('aria-selected', String(index === selectedIndex));
        });
      }

      handleDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) {
          this.close();
        }
      }

      handleKeydown(event) {
        const activeIndex = this.items.indexOf(document.activeElement);

        if (event.key === 'Escape' && this.isOpen) {
          event.preventDefault();
          this.close({ restoreFocus: true });
          return;
        }

        if (event.target === this.trigger && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          this.open();
          return;
        }

        if (!this.isOpen || activeIndex < 0) return;

        let nextIndex = activeIndex;

        if (event.key === 'ArrowDown') nextIndex = (activeIndex + 1) % this.items.length;
        if (event.key === 'ArrowUp') nextIndex = (activeIndex - 1 + this.items.length) % this.items.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.items.length - 1;

        if (nextIndex !== activeIndex) {
          event.preventDefault();
          this.items[nextIndex].focus();
        }
      }
    }

    customElements.define('variant-custom-select', VariantCustomSelect);
  }
  } catch(e) { console.error(e); }
})();

})();
